// declare module "@capacitor/core" {
//   interface PluginRegistry {
//     Contacts: ContactsPlugin;
//   }
// }
export var ContactType;
(function (ContactType) {
    ContactType[ContactType["Person"] = 0] = "Person";
    ContactType[ContactType["Organization"] = 1] = "Organization";
})(ContactType || (ContactType = {}));
//# sourceMappingURL=definitions.js.map